import React, { useState, useEffect, useContext, useMemo } from 'react'
import {
  Box,
  Grid, Select, FormControl, OutlinedInput, MenuItem, InputLabel, Stack, Typography
} from '@mui/material';
import styles from './Profiles.module.css';
import MapComponent from './Map/MapComponent';

const defaultCenter = [41.83730086220008, -87.66876030777101];
const defaultZoom = 11;

export const Locations = (props) => {
  //default position and zoom for map
  const [center, setCenter] = React.useState(defaultCenter);
  const [zoom, setZoom] = React.useState(defaultZoom);
  const [isDefault, setIsDefault] = React.useState(true);

  return (
    <Grid
      container
      spacing={0}
    >
      <Grid
        item
        xs={12}
        md={4}
      >
        <Typography variant="h6" sx={{ marginBottom: 2 }}>Notification Locations</Typography>
        <Typography variant="body2" sx={{ marginBottom: 0, marginTop: 2 }}>Define areas in which you want to receive alerts:</Typography>
        <Typography variant="body2" sx={{marginTop: 1 }} component="div">
          <ul>
            <li>Click on the Rectange icon to create an area</li>
            <li>Drag to resize the new area</li>
            <li>Click the Edit icon to move or resize areas</li>
            <li>User may have up to 10 areas per profile</li>
            <li>Note: Returning to this page to edit locations may reset location areas.</li>
          </ul>
        </Typography>
      </Grid>
      <Grid
        item
        xs={12}
        md={8}
      >
        <Box sx={{ height: 500, paddingBottom: 0 }}>
          <MapComponent className={styles.profileMap} center={center} zoom={zoom} defaultCenter={defaultCenter} defaultZoom={defaultZoom} setIsDefault={setIsDefault} {...props}/>
        </Box>
      </Grid>
    </Grid>

  )
}


